import React, { useEffect } from 'react';
import SidebarMenuItem from './components/sidebar-menu-item/sidebar-menu-item';
import { SideBarStyled } from './sidebar.styled';
import TBAlert from './components/sidebar-menu-item/tb-alert/tb-alert';
import { useDispatch, useSelector } from 'react-redux';
import {partialUserResetAction, tbRegistrationAction } from '../../../../../store/user.store';
import { useModal } from '../../../modal-provider/hooks/modal-provider.hook';
import { ModalVariant } from '../../../modal-provider/components/modal/modal.constants';
import i18n from '../../../../../translations/strings';

export interface SidebarProps {
  pageSelected: string;
  buttons: any[];
  isHamburgerClicked: boolean;
}

const Sidebar = (props: SidebarProps) => {
  const { user, loading, error, tbRegistrationSuccess } = useSelector((state: any) => {
    return state.user;
  });
  const dispatch = useDispatch();
  const { openModal } = useModal();

  useEffect(() => {
    if (error) {
      openModal({
        message: error,
        variant: ModalVariant.Error,
      });
      dispatch(partialUserResetAction());
    }
  }, [error]);

  useEffect(() => {
    if (tbRegistrationSuccess) {
      dispatch(partialUserResetAction());
    }
  }, [tbRegistrationSuccess]);

  return (
    <SideBarStyled.Container
      display={props.isHamburgerClicked ? null : { xs: 'none', md: 'block' }}
      md={2}
      item
      isHamburgerClicked={props.isHamburgerClicked}
    >
      <SideBarStyled.ContainerContent>
        <SideBarStyled.ContainerButtons>
          {props.buttons.map((button, index) => (
            <SidebarMenuItem
              button={button}
              selected={props.pageSelected === button.id}
              key={index.toString()}
            />
          ))}
        </SideBarStyled.ContainerButtons>
        <SideBarStyled.ContainerTBAlert>
          {!user.things_board_registration && (
            <TBAlert
              loading={loading}
              onClick={() => dispatch(tbRegistrationAction())}
              title={i18n.t('tbAlert.title')}
              description={i18n.t('tbAlert.description')}
              textButton={i18n.t('tbAlert.fix')}
            />
          )}
        </SideBarStyled.ContainerTBAlert>
      </SideBarStyled.ContainerContent>
    </SideBarStyled.Container>
  );
};

export default Sidebar;
